module.exports = __webpack_public_path__ + "static/media/video-emilie.1271a364.mp4";